import { ia, iaRa } from 'lib/helpers/utility';

export function applyFilters(data, filters) {
  return iaRa(data).filter((item) => {
    if (filters && typeof filters === 'object' && !ia(filters)) {
      return Object.entries(filters).every(([field, conditions]) => {
        const conditionsArray = ia(conditions) ? conditions : [conditions];

        return conditionsArray.some((condition) => {
          const fieldValue = String(item[field] ?? '');

          if (ia(condition.values)) {
            if (condition.formula === 'contains') {
              return condition.values.some((value) =>
                fieldValue.toLowerCase().includes(String(value).toLowerCase())
              );
            } else if (condition.formula === 'does not contain') {
              return condition.values.every(
                (value) => !fieldValue.toLowerCase().includes(String(value).toLowerCase())
              );
            } else if (condition.formula === 'is') {
              return condition.values.some((value) => fieldValue === String(value));
            } else if (condition.formula === 'is not') {
              return condition.values.every((value) => fieldValue !== String(value));
            }
            return false;
          } else {
            const filterValue = String(condition.values);

            if (condition.formula === 'contains') {
              return fieldValue.toLowerCase().includes(filterValue.toLowerCase());
            } else if (condition.formula === 'does not contain') {
              return !fieldValue.toLowerCase().includes(filterValue.toLowerCase());
            } else if (condition.formula === 'is') {
              return fieldValue === filterValue;
            } else if (condition.formula === 'is not') {
              return fieldValue !== filterValue;
            }
            return false;
          }
        });
      });
    }

    if (ia(filters)) {
      return filters.every((filterGroup) => {
        return Object.entries(filterGroup).every(([field, conditions]) => {
          return conditions.some((condition) => {
            const fieldValue = String(item[field] ?? '');

            if (ia(condition.values)) {
              if (condition.formula === 'contains') {
                return condition.values.some((value) =>
                  fieldValue.toLowerCase().includes(String(value).toLowerCase())
                );
              } else if (condition.formula === 'does not contain') {
                return condition.values.every(
                  (value) => !fieldValue.toLowerCase().includes(String(value).toLowerCase())
                );
              } else if (condition.formula === 'is') {
                return condition.values.some((value) => fieldValue === String(value));
              } else if (condition.formula === 'is not') {
                return condition.values.every((value) => fieldValue !== String(value));
              }
              return false;
            } else {
              const filterValue = String(condition.values);

              if (condition.formula === 'contains') {
                return fieldValue.toLowerCase().includes(filterValue.toLowerCase());
              } else if (condition.formula === 'does not contain') {
                return !fieldValue.toLowerCase().includes(filterValue.toLowerCase());
              } else if (condition.formula === 'is') {
                return fieldValue === filterValue;
              } else if (condition.formula === 'is not') {
                return fieldValue !== filterValue;
              }
              return false;
            }
          });
        });
      });
    }

    return true;
  });
}
